/* ==========================================================================
   crocs-wishlist @ 2.0.0 — el corazon de la ficha delega en Wishlist Hero

   Antes este boton era un <a href="#hero-wishlist">. La app ata ese ancla en
   todo el sitio para ABRIR la lista, asi que el corazon de la ficha terminaba
   siendo un espejo del header en vez de agregar el producto.

   Por que no se usa el SDK
   ------------------------
   La app publica window.WishListHero_SDK, pero su plan en esta tienda no
   habilita la JS API: cada funcion devuelve
   {ok:false, status:403, error:"This feature is available for paid plans..."}
   en lugar del dato, y el validador termina rechazando el payload con
   "Expected a string, but received: [object Object]". Falla en silencio.

   Como funciona entonces
   ----------------------
   El renderer de .wishlist-hero-custom-button no pasa por esa guarda de plan:
   es el mismo camino del boton que la app ya dibuja bien. La seccion imprime
   uno de esos divs oculto al lado del corazon, la app le monta dentro su propio
   <button>, y aca se le delegan los clicks y se le copia el estado.

   El estado sale del storage de la app (localStorage wishlisthero_ + wl-itms),
   que es su fuente de verdad y no depende de como React dibuje el boton. Si no
   se puede leer se cae a mirar el texto del boton, y por ultimo su icono.
   ========================================================================== */

(function () {
  'use strict';

  var SELECTOR = '[data-crocs-wishlist]';
  var PROXY = '[data-crocs-wishlist-proxy]';
  var EVENT_UPDATED = 'wishlist-hero-wishlist-updated';
  var EVENT_MOUNT = 'wishlist-hero-add-to-custom-element';
  var MOUNT_RETRY = 1200;
  var STORAGE_KEY = 'wl-itms';
  /* La app emite wishlist-updated ANTES de guardar en storage, asi que un solo
     repintado leeria el estado viejo. */
  var SETTLE = 350;

  function warn(message) {
    console.warn('[crocs-wishlist] ' + message);
  }

  function settings() {
    return window.WishListHero_setting || {};
  }

  /* Los items viven en localStorage bajo una clave con el prefijo de la app.
     Se busca por coincidencia parcial para no depender del separador exacto que
     use su libreria de storage. */
  function storedItems() {
    var key = null;
    var parsed;
    var i;

    try {
      for (i = 0; i < window.localStorage.length; i++) {
        if (window.localStorage.key(i).indexOf(STORAGE_KEY) !== -1) {
          key = window.localStorage.key(i);
          break;
        }
      }
      if (!key) return null;
      parsed = JSON.parse(window.localStorage.getItem(key));
    } catch (e) {
      // Modo privado, cookies bloqueadas o formato nuevo: se usa el respaldo.
      return null;
    }

    return parsed && parsed.length ? parsed : null;
  }

  /* La wishlist de la app es por variante y el form es quien sigue la talla
     elegida: product-info reescribe ese input en cada cambio. */
  function variantId(btn) {
    var input = document.querySelector('[data-product-form] [name="id"]');
    var proxy = proxyFor(btn);
    var fallback = proxy ? proxy.getAttribute('data-wlh-variantId') : '';

    return String((input && input.value) || fallback || '');
  }

  function inStoredList(btn) {
    var items = storedItems();
    var id;
    var item;
    var i;

    if (!items) return null;

    id = variantId(btn);
    if (!id) return null;

    for (i = 0; i < items.length; i++) {
      item = items[i] || {};
      if (String(item.ProductVariantId || item.productVariantId || '') === String(id)) {
        return true;
      }
    }
    return false;
  }

  /* El div de la app es hermano del corazon: los imprime juntos la seccion. */
  function proxyFor(btn) {
    return btn.parentNode ? btn.parentNode.querySelector(PROXY) : null;
  }

  function appButtonFor(btn) {
    var proxy = proxyFor(btn);
    return proxy ? proxy.querySelector('button') : null;
  }

  function norm(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isAdded(appBtn) {
    var after = norm(settings().ButtonTextAfterAdding);
    var before = norm(settings().ButtonTextBeforeAdding);
    var label = norm(appBtn.getAttribute('aria-label'));
    var text = norm(appBtn.textContent);
    var icon;

    /* La app cambia el texto visible al agregar; el aria-label no siempre
       acompana, por eso se miran los dos. */
    if (after && (label === after || text === after)) return true;
    if (before && (label === before || text === before)) return false;

    /* Ultimo respaldo: su icono es FontAwesome y pasa de contorno (far) a
       solido (fas) al entrar en la lista. */
    icon = appBtn.querySelector('svg[data-prefix]');
    return !!icon && icon.getAttribute('data-prefix') === 'fas';
  }

  function paint(btn) {
    var appBtn = appButtonFor(btn);
    var active = inStoredList(btn);
    var label;

    // Sin storage legible se cae al estado que muestra el boton de la app.
    if (active === null) {
      if (!appBtn) return;
      active = isAdded(appBtn);
    }
    label = active
      ? btn.getAttribute('data-wishlist-label-remove')
      : btn.getAttribute('data-wishlist-label-add');

    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    if (label) btn.setAttribute('aria-label', label);
  }

  function paintAll() {
    var btns = document.querySelectorAll(SELECTOR);
    var i;
    for (i = 0; i < btns.length; i++) paint(btns[i]);
  }

  function onClick(event) {
    var btn = event.currentTarget;
    var appBtn = appButtonFor(btn);

    if (!appBtn) {
      warn('la app todavia no monto su boton: no hay a quien delegarle el click.');
      return;
    }
    appBtn.click();
  }

  /* La app barre los .wishlist-hero-custom-button una sola vez al arrancar. Si
     el nuestro llego despues --editor de temas, o su bundle todavia cargando--
     hay que avisarle con este evento, el mismo que usa su SDK. */
  function mount(btn) {
    var proxy = proxyFor(btn);

    if (!proxy) {
      warn('falta el ' + PROXY + ' que monta el boton de la app.');
      return;
    }

    setTimeout(function () {
      if (proxy.querySelector('button')) {
        paint(btn);
        return;
      }

      document.dispatchEvent(new CustomEvent(EVENT_MOUNT, { detail: proxy }));

      setTimeout(function () {
        if (!proxy.querySelector('button')) {
          warn('la app no monto su boton; revisar que la extension este activa.');
        }
        paint(btn);
      }, MOUNT_RETRY);
    }, MOUNT_RETRY);
  }

  /* El boton de la app se redibuja entero al cambiar de estado, asi que hay que
     mirar el subarbol y no un atributo puntual. */
  function observe(btn) {
    var proxy = proxyFor(btn);
    var observer;

    if (!proxy || typeof MutationObserver === 'undefined') return;

    observer = new MutationObserver(function () {
      paint(btn);
    });
    observer.observe(proxy, {
      childList: true,
      subtree: true,
      attributes: true,
      // El texto del boton es lo que la app cambia siempre al agregar o quitar.
      characterData: true,
    });
  }

  function init() {
    var btns = document.querySelectorAll(SELECTOR);
    var btn;
    var i;

    for (i = 0; i < btns.length; i++) {
      btn = btns[i];
      if (btn.dataset.crocsWishlistReady) continue;
      btn.dataset.crocsWishlistReady = 'true';

      btn.addEventListener('click', onClick);
      observe(btn);
      mount(btn);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  document.addEventListener(EVENT_UPDATED, function () {
    paintAll();
    setTimeout(paintAll, SETTLE);
  });

  /* Cambiar de talla cambia la variante, y la lista es por variante. */
  document.addEventListener('change', function (event) {
    if (event.target && event.target.name === 'id') paintAll();
  });
})();
